module.exports = __webpack_public_path__ + "static/img/eat-type-bg.3b7952aa.png";